export const urls = {
  applyCampaignJourney: () => `/api/client/v1/marketing/campaign-journeys/apply/`,
  consentPreferences: () => "/api/client/v1/marketing/consent-preferences/",
};

export const keys = {
  all: () => ["marketing-consent"],
  consentPreferences: () => [...keys.all(), "preferences"],
};

export const externalUrls = {
  typeformDataRequest: "https://vetcove.typeform.com/to/Waqxg6u1",
  gpc: "https://globalprivacycontrol.org",
};
